/**
 * Booking link builder — creates React-Router state object compatible with
 * BookingDetails.js:253-278 (which reads location.state.fromLocation/.toLocation).
 *
 * IMPORTANT: BookingDetails.js is NEVER modified. This module builds the
 * exact same shape that Landing.js:423 already produces, so the booking
 * flow prefills naturally.
 */

/**
 * Build the state payload for navigate('/booking', {state: ...}).
 * @param {object} route  seoConfig ROUTES entry with from/to/fromCoords/toCoords/km/min
 * @returns {object} state payload — do not mutate.
 */
export function buildBookingState(route) {
  if (!route || !route.fromCoords || !route.toCoords) return null;
  return {
    fromLocation: {
      lat: route.fromCoords.lat,
      lng: route.fromCoords.lng,
      address: route.from,
      place_id: `seo_${route.fromSlug}`,
      region: null,
    },
    toLocation: {
      lat: route.toCoords.lat,
      lng: route.toCoords.lng,
      address: route.to,
      place_id: `seo_${route.toSlug}`,
      region: null,
    },
    routeInfo: {
      distance: route.km,
      duration: route.min,
    },
    // Provenance marker for analytics — booking flow ignores unknown fields.
    __source: 'quote_widget',
  };
}
